{
  "register-secret-data-page": {
    "buttons": {
      "back": "Zurück",
      "submit": "Einreichen"
    },
    "text": {
      "login-data": "Ihre Anmeldedaten",
      "login-data-hint": "Sie müssen Ihre Anmeldedaten eingeben"
    }
  }
}
